import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardTitle } from '@/components/ui/card';

export default function Home({ darkMode }: { darkMode: boolean }) {
    const bg = darkMode
        ? 'bg-gray-900 text-white'
        : 'bg-gradient-to-br from-indigo-300 via-purple-300 to-pink-200 text-gray-900';
    const cardBg = darkMode ? 'bg-gray-800' : 'bg-white/80';

    return (
        <div className={`min-h-screen flex flex-col items-center justify-center px-4 py-10 ${bg}`}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center max-w-3xl"
            >
                <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">
                    Nebula Network
                </h1>
                <p className="text-xl md:text-2xl mb-6 font-light">
                    Master the dark. Crack the code. Conquer the lobby.
                </p>
                <Link to="/calculators/sv">
                    <Button className="px-6 py-3 text-lg shadow-lg hover:scale-105 transition-transform">
                        Get Started
                    </Button>
                </Link>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl w-full"
            >
                {[
                    {
                        title: 'Powerful Calculators',
                        desc: 'Auto-solve code challenges with pixel-perfect tools.',
                    },
                    {
                        title: 'Fully-Automated Bots',
                        desc: 'Generate XP, unlock rewards, or complete missions hands-free.',
                    },
                    {
                        title: 'Secure & Anonymous',
                        desc: 'No account required. Your data stays yours.',
                    },
                ].map(({ title, desc }, i) => (
                    <Card key={i} className={`rounded-2xl shadow-lg backdrop-blur ${cardBg}`}>
                        <CardContent className="p-6 text-center">
                            <CardTitle className="text-xl font-semibold mb-2">
                                {title}
                            </CardTitle>
                            <p className="text-sm opacity-80">{desc}</p>
                        </CardContent>
                    </Card>
                ))}
            </motion.div>

            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="mt-20 text-center"
            >
                <Link to="/lobby">
                    <Button size="lg" className="px-8 py-4 text-lg font-bold shadow-xl hover:scale-105 transition">
                        Join the Bot Lobby
                    </Button>
                </Link>
            </motion.div>
        </div>
    );
}
